import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { bkgdHangulTop, bkgdKanaTop, black, tomokoExcitedDefault, kfzCharStandard } from '.'
import { WritingGuideHeader } from 'src/components/ui/styledComponents'

const mobileTopSectionWrapper = css`
  grid-template-columns: 1fr;
  justify-items: center;

  @media (max-width: 1000px) { padding-bottom: 0px; }
`

export const TopSectionWrapper = styled.section<{ language?: string }>`
  background-image: url(${(props) => props.language === 'Korean' ? bkgdHangulTop : bkgdKanaTop});
  background-size: cover;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 64px 24px 32px;
  gap: 32px;
  overflow: hidden;

  @media (max-width: 1400px) { grid-template-columns: 1fr auto; }
  @media (max-width: 1212px) {
    ${mobileTopSectionWrapper}
  }
  // replacing tomoko img with background image to prevent overflow on mobile
  @media (max-width: 470px) {
    background-image: url(${bkgdKanaTop}), url(${(props) => props.language === 'Japanese' ? tomokoExcitedDefault : kfzCharStandard});
    background-size: cover, 423px;
    background-position: center, center 65px;
    background-repeat: repeat, no-repeat;
  }
`

const mobileLeftGrid = css`
  grid-template-columns: 1fr;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 24px 0;
  margin: 48px 0;

  @media (max-width: 575px) { padding: 12px 0; margin: 30px 0 60px; }
`

export const LeftGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: end;
  align-content: start;
  align-items: start;
  gap: 4px;
  padding-top: 100px;
  
  @media (max-width: 1212px) {
    ${mobileLeftGrid}
  }
`

export const BannerText = styled(WritingGuideHeader)`
  color: ${black};
  font-size: 4rem !important;
  justify-self: left; 

  @media (max-width: 1212px) { font-size: 3.5rem !important; }
  @media (max-width: 575px) { font-size: 2.75rem !important; }
  @media (max-width: 400px) { font-size: 2.25rem !important; }
`

export const ButtonArrow = styled.img`
  height: 100%;
  grid-row: span 4;
  grid-column: 1;
  padding: 20px 10px;
`

const mobileTomoko = css`
  position: absolute;
  grid-row: 1;
  grid-column: 1;
  z-index: -1;
  justify-self: center;

  @media (max-width: 575px) { height: 500px; min-width: 424px; }
  @media (max-width: 470px) { display: none; }
`

export const Tomoko = styled.img<{ language?: string }>`
  height: 600px;
  transform: scaleX(-1) ${(props) => props.language === 'Japanese' && 'rotate(-10deg)'};

  @media (max-width: 1212px) {
    transform: unset;
    ${mobileTomoko}
  }
`

export const Yuna = styled(Tomoko)`

`

export const MobileSpeechBubble = styled.img<{ language?: string }>`
  height: 225px;
  position: relative;
  left: ${(props) => props.language === 'Japanese' ? '-125px' : '-135px'};
  ${(props) => props.language === 'Korean' && 'top: 50px;'}

  @media (max-width: 575px) {
    height: unset;
    left: ${(props) => props.language === 'Japanese' ? '-110px' : '-120px'};
    top: ${(props) => props.language === 'Japanese' ? '-10px' : '30px'};
  }
  @media (max-width: 390px) {
    left: ${(props) => props.language === 'Japanese' ? '-90px' : '-100px'};
    ${(props) => props.language === 'Korean' && 'top: 50px;'}
  }
`

export const LookingForSounds = styled.button`
  background-color: white;
  border: none;
  color: ${black};
  font-family: 'Tilt Warp';
  font-size: 1.5rem;
  padding: 12px 24px;
  position: absolute;
  border-radius: 24px;
  min-width: 320px;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 0 9px rgba(0, 0, 0, 0.1);
  z-index: 1;
  color: #aab;

  svg {
    bottom: 1px;
    position: relative;
  }

  svg, span {
    display: inline;
    color: #7bbbff;
  }

  @media (max-width: 870px) {
    top: 80px;
    font-size: 1.25rem;
  }

  @media (max-width: 744px) {
    font-size: 1rem;
  }

  @media (max-width: 500px) {
    width: 100%;
    border-radius: 0px;
    top: 70px;
  }
`

//
// inline JS styles
//

export const rBStyles = {
  justifySelf: 'left',
  marginLeft: '12px'
}

export const mobileRBStyles = {
  justifySelf: 'center',
  margin: '12px 12px 0 12px'
}
